// export const BASE_API_URL = "http://192.168.29.49:5000/api/items" //TEST
// export const BASE_API_URL = "http://192.168.29.121:5000/api/items" //TEST
// export const BASE_API_URL = "http://localhost:5000/api/items" //TEST


export const BASE_API_URL = "https://45-61-61-227.cloud-xip.com/snowball/api/items" //TEST

